export function isRangeType(type) {
  if (typeof type !== "string" || !type) return false;
  const t = type.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  return t.includes("kuran") || t.includes("cevsen");
}
